import React, { FC,  useEffect, useRef, useState } from "react";

// eslint-disable-next-line import/no-webpack-loader-syntax
import mapboxgl from '!mapbox-gl';

import { get, post } from "../fetchers/fetchers";
import {
    IAssessmentProject,
} from "../types/types";

import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow, TextField
} from "@material-ui/core";
import { useParams } from "react-router";
import {  useTask } from '../stateManagement/context';
import { API_URL } from "../env";

mapboxgl.accessToken = 'pk.eyJ1IjoiY2hyaXN0aWFudXJpY2giLCJhIjoiY2tpaWx2dnZpMDN5YTJ5cDBxajNibjBtNSJ9.sd3Q-4QrSLopA-WTs0Fc2g';

interface IOverviewProps {

}

interface IRouteParams {
    id: string
}



const DamOverview: FC<IOverviewProps> = () => {

    let tasks = useTask()

    const [write_access, setWriteAccess] = useState<boolean>(false);

    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [reload, setReload] = useState<boolean>(false);
    const params = useParams<IRouteParams>()

    const [loadingValley, setLoadingValley] = useState(false);
    const [loadingLat, setLoadingLat] = useState(false);
    const [loadingLng, setLoadingLng] = useState(false);

    const [valley, setValley] = useState<string>('');
    const [latitude, setLatitude] = useState<number>(-33.52);
    const [longitude, setLongitude] = useState<number>(151.12);
    const [zoom, setZoom] = useState(9);
    const [damId, setDamId] = useState<number>(-1);

    const mapContainer = useRef<any>(null);
    const map = useRef<any>(null);
    const [lng, setLng] = useState(151.12);
    const [lat, setLat] = useState(-33.52);

    const [marker, setMarker] = useState<any>(null);



    const [assessment, setAssessment] = useState<IAssessmentProject>();


    const getAssessment = async () => {
        const d = await get<IAssessmentProject>(API_URL + "assessment_project/" + params.id)
        setAssessment(d);
        if (d?.dam?.id) {
            setDamId(d?.dam?.id);
        }
        if (d?.dam?.valley) {
            setValley(d?.dam?.valley);
        }
        if (d?.dam?.latitude) {
            setLatitude(d?.dam?.latitude);
            setLat(d?.dam?.latitude);
        }
        if (d?.dam?.longitude) {
            setLongitude(d?.dam?.longitude);
            setLng(d?.dam?.longitude);
        }
    }

    const updateValley = async (newValley: string) => {
        setLoadingValley(true);
        await post(API_URL + "dams/" + assessment?.dam?.project_id, {
            id: damId,
            valley: newValley,
        });
        setLoadingValley(false);
    };

    const updateLatitude = async (newLat: number) => {
        setLoadingLat(true);

        await post(API_URL + "dams/" + assessment?.dam?.project_id, {
            id: damId,
            latitude: newLat,
        });
        setLoadingLat(false);
        setReload(true)
    };

    const updateLongitude = async (newLng: number) => {
        setLoadingLng(true);
        await post(API_URL + "dams/" + assessment?.dam?.project_id, {
            id: damId,
            longitude: newLng,
        });
        setLoadingLng(false);
        setReload(true)
    };

    useEffect(() => {
        setWriteAccess(tasks.write_access)
    },[tasks])


    useEffect(() => {
        if (!isLoaded && !isLoading) {
            setIsLoading(true)
            getAssessment().then(
                () => {
                    setIsLoading(false)
                    setIsLoaded(true)

                }
            )
        }
        if (isLoaded) {
            if (!map.current) {
                map.current = new mapboxgl.Map({
                    container: mapContainer.current,
                    style: 'mapbox://styles/mapbox/streets-v11',
                    center: [longitude, latitude],
                    zoom: zoom
                })

                const marker1 = new mapboxgl.Marker()
                    .setLngLat([longitude, latitude])
                    .addTo(map.current);

                setMarker(marker1)
            }
        }
        if (isLoaded && reload) {
            if (map.current) {
                // remove old marker
                marker.remove();
            }
            const marker1 = new mapboxgl.Marker()
                .setLngLat([longitude, latitude])
                .addTo(map.current);

            setMarker(marker1)

            // set center of map to new marker with transition
            map.current.flyTo({
                center: [longitude, latitude],
                zoom: zoom,
                essential: true // this animation is considered essential with respect to prefers-reduced-motion
            });
            setReload(false)
            // Create a default Marker and add it to the map.

        };


    }, [map, mapContainer, isLoaded, getAssessment, reload, setReload])

    return (
        <>
            <Paper variant={"outlined"} style={{ display: "flex", flexDirection: "column", height: "100%", margin: "10px", flex: 1 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell></TableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>Valley</TableCell>
                            <TableCell>
                                <TextField
                                    value={valley}
                                    disabled={loadingValley || !write_access}
                                    onChange={(e) => setValley(e.target.value)}
                                    onBlur={() => updateValley(valley)}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Latitude</TableCell>
                            <TableCell>
                                <TextField
                                    type="number"
                                    value={latitude}
                                    disabled={loadingLat  || !write_access}
                                    onChange={(e) => setLatitude(+e.target.value)}
                                    onBlur={() => updateLatitude(latitude)}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Longitude</TableCell>
                            <TableCell>
                                <TextField
                                    type="number"
                                    value={longitude}
                                    disabled={loadingLng  || !write_access}
                                    onChange={(e) => setLongitude(+e.target.value)}
                                    onBlur={() => updateLongitude(longitude)}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <div>
                    <div ref={mapContainer} style={{ "height": "400px" }} />
                </div>


            </Paper>
        </>
    );
}

export default DamOverview;
